import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';

import { useAuthenticatedUser } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import { Avatar, Heading3, Paragraph, PlainCard, Skeleton } from '@treams/treams-ui';

export default Skeleton(
	function OutgoingFeedbackCard(props: { response: graphql.FeedbackResponse; userID: string }) {
		const { t } = useTranslation();
		const viewer = useAuthenticatedUser();

		return (
			<PlainCard
				to={
					viewer.id === props.userID
						? `/feedback/given/${props.response.id}`
						: `/users/${props.userID}/feedback/given/${props.response.id}`
				}
			>
				<Flex alignItems="center" style={{ gap: 16 }}>
					<Avatar size={48} user={props.response.requestor} />
					<Box flexGrow={1} flexShrink={1} minWidth={0}>
						<Heading3>{props.response.title || t('feedback.outgoing.card.title')}</Heading3>
						<Paragraph mt="4px">
							{t('feedback.outgoing.card.to')}
							&nbsp;
							{[props.response.requestor.firstName, props.response.requestor.lastName].join(' ')}
							{' · '}
							{t('feedback.outgoing.card.createdAt', {
								date: moment(props.response.sharedAt).format('LL'),
							})}
						</Paragraph>
					</Box>
				</Flex>
			</PlainCard>
		);
	},
	function OutgoingFeedbackCardSkeleton() {
		return (
			<PlainCard.Skeleton>
				<Flex alignItems="center" style={{ gap: 16 }}>
					<Avatar.Skeleton size={48} />
					<Box flexGrow={1} flexShrink={1}>
						<Heading3.Skeleton />
						<Paragraph.Skeleton mt="4px" lines={1} />
					</Box>
				</Flex>
			</PlainCard.Skeleton>
		);
	},
);
